import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import IPageViewModel from '../../../interfaces/umbracoNodes/pageViewModel';
import Wizard from '../../wizard';
import * as StyledRegisterShipmentForm from './registerShipmentForm.styles';
import StepConfirmation from './stepConfirmation';
import StepExport from './stepExport';
import StepInfo from './stepInfo';
import StepReceipt from './stepReceipt';
import StepShipment from './stepShipment';

export interface PresetRecipient {
	name: string;
	address: string;
	ssn: string;
	postcode: string;
}

interface Props {
	page: IPageViewModel;
	side?: 'left' | 'right';
	presetRecipient?: PresetRecipient | null;
}

const RegisterShipmentForm: FC<Props> = ({ page, side, presetRecipient }) => {
	const { stepInfoFormInfo } = useSelector(({ registerShipmentReducer }) => registerShipmentReducer);
	const internationalShipment = stepInfoFormInfo?.country && stepInfoFormInfo?.country.value !== 'IS';
	const { t } = useTranslation('registerShipment');
	const [initialStep, setInitialStep] = useState<number>(presetRecipient ? 2 : 0); // Skip to Confirmation step (2) for Metta sport

	useEffect(() => {
		if (!presetRecipient) {
			setInitialStep(0);
		}
	}, [presetRecipient]);

	return (
		<StyledRegisterShipmentForm.Wrapper>
			<Wizard
				internationalShipment={internationalShipment}
				isRegShipment
				side={side}
				initialStep={initialStep}
				hideWizardSteps={!!presetRecipient}
				disablePrevStep={!!presetRecipient}>
				<StepInfo name={t('shared.information')} page={page} />
				<StepShipment name={t('shared.shipment')} page={page} />
				{internationalShipment && <StepExport name={t('shared.customs')} page={page} />}
				<StepConfirmation name={t('shared.overview')} isReturn={!!presetRecipient} />
				<StepReceipt name={t('shared.receipt')} page={page} />
			</Wizard>
		</StyledRegisterShipmentForm.Wrapper>
	);
};

export default RegisterShipmentForm;
